import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from '../pages/app'
import { setupApolloClient } from '../config/graphql'

const uri = `/graphql?tenantId=DFT`
const apolloClient = setupApolloClient({ uri })

ReactDOM.hydrateRoot(
  document.getElementById('app'),
  <BrowserRouter>
    <App apolloClient={apolloClient} />
  </BrowserRouter>
)
